import React, { useMemo } from 'react';
import { useNavigation } from 'react-router-dom';
import { useTheme } from '@mui/material';
import { paths } from '@/app/routes';
import { ClientNameAndAvatar } from '@/components/table/ClientNameAndAvatar';
import { useGetClientRowQuery } from '@/features/clients/clientsApi';
import { useGetDealRowQuery } from '@/features/deals/dealsApi';
import { getDealClientId } from '@/features/deals/helper';
import FolioLink from '@/components/FolioLink';

const getDealInitials = (name) => {
	if (!name) {
		return 'NA';
	}

	const names = name.split(' ');

	if (names.length === 2) {
		return names[0].charAt(0).toUpperCase() + names[1].charAt(0).toUpperCase();
	}

	return name.length >= 2 ? name.substring(0, 2).toUpperCase() : name.toUpperCase();
};

const WIDTH = 250;

export const DataGridTaskClientName = ({ row }) => {
	const navigation = useNavigation();
	const theme = useTheme();
	const isDarkMode = theme.palette.mode === 'dark';
	const { dealId, clientId, clientName, relationshipCompanyId } = row;

	const { data: dealData } = useGetDealRowQuery(dealId, {
		skip: !dealId,
	});

	const resolvedClientId = clientId ?? getDealClientId(dealData);

	const { data: clientData } = useGetClientRowQuery(resolvedClientId, {
		skip: !resolvedClientId,
	});

	const taskOwnerName = clientData?.name || dealData?.dealName || clientName;

	const link = resolvedClientId ? `${paths.clients}/${resolvedClientId}` : null;

	const isLoadingLink =
		navigation.state === 'loading' &&
		resolvedClientId &&
		navigation?.location?.pathname?.includes(resolvedClientId);

	const sharedParams = useMemo(
		() => ({
			title: taskOwnerName,
			initials: getDealInitials(taskOwnerName),
			width: WIDTH,
		}),
		[taskOwnerName],
	);

	if (!taskOwnerName) return '-';

	if (!link) {
		return <ClientNameAndAvatar {...sharedParams} />;
	}

	return (
		<FolioLink
			to={link}
			state={{ task: row.id }}
			stopPropagation
			sx={{ display: 'inline-block', cursor: 'pointer' }}
		>
			<ClientNameAndAvatar
				{...sharedParams}
				colour={
					isLoadingLink
						? isDarkMode
							? theme.palette.folioPurpleAccentMid
							: theme.palette.folioPurpleAccent
						: 'inherit'
				}
				sx={{
					'&:hover': {
						color: theme.palette.primary.main,
					},
				}}
			/>
		</FolioLink>
	);
};
